import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ChargesStoreModule } from './store'

@NgModule({
  imports: [CommonModule, ChargesStoreModule],
  exports: [ChargesStoreModule],
})
export class ChargesLibraryModule {}
